import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import Slider from 'react-slick';

// import * as pages from '../../../constants/data/pages';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import IntroTitlePage from './IntroTitlePage';
import IntroMessagePage from './IntroMessagePage';
import LooseDiamondPage from './LooseDiamondPage';
import ContactPage from './ContactPage';
import {ProductPageContainer} from './ProductPage';

class Page extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    let startingPage = 0;
    let pageCount = 96;

    let pagesArray = [];
    for(let i = 0; i < pageCount; i++) {
      pagesArray.push((i + 1).toString());
    }

    console.log(pagesArray);

    this.state = {
      currentPage: startingPage,
      currentPageOffset: 0,
      singlePageBreak: 768,
      pages: pagesArray,
      lastNav: 0,
    };
	}

  componentDidUpdate(prevProps, prevState) {
    
  }

  leftNav() {

    let newPage = this.state.currentPage;
    let newPageOffset = this.state.currentPageOffset;

    if(window.innerWidth <= this.state.singlePageBreak) {
      newPageOffset--;
      if(newPageOffset < 0) {
        newPageOffset = 1;
        newPage -= 2;
      }
    } else {
      newPage -= 2;
      newPageOffset = 0;
    }

    if(newPage < 0) {
      newPage = 0;
    }

    this.setState({
      currentPage: newPage,
      currentPageOffset: newPageOffset,
    });
  }

  rightNav() {

    let newPage = this.state.currentPage;
    let newPageOffset = this.state.currentPageOffset;

    if(window.innerWidth <= this.state.singlePageBreak) {
      newPageOffset++;
      if(newPageOffset > 1) {
        newPageOffset = 0;
        newPage += 2;
      }
    } else {
      newPage += 2;
      newPageOffset = 0;
    }

    if(newPage > this.state.pages.length - 3) {
      // this.context.router.push('/thankyou');
      this.setState({
        currentPage: newPage,
        currentPageOffset: newPageOffset,
      });
    } else {

      this.setState({
        currentPage: newPage,
        currentPageOffset: newPageOffset,
      });
    }
  }

  getEffectivePage() {
    if(window.innerWidth <= this.state.singlePageBreak) {
      return this.state.currentPage + this.state.currentPageOffset;
    } else {
      return this.state.currentPage;
    }
    // return 0;
  }

  renderInternalElement(page) {   
    return <img src={'/img/pages/' + page + '.jpg'} />;
  }

  renderPage(page, index) {

    console.log(this.state.currentPage);

    let wrapperClass = 'notVisible';
    if(this.getEffectivePage() === index) {
      wrapperClass = 'leftPage';
    } else if(this.getEffectivePage() + 1 === index) {
      wrapperClass = 'rightPage';
    }

    return (
      <div key={index} className={'pageContentWrapper ' + wrapperClass}>
        {this.renderInternalElement(page)}
      </div>
    );
  }

  nextSlide() {
    if((Date.now() - this.state.lastNav) > 500) {
      this.setState({
        lastNav: Date.now(),
      }, () => {
        this.sliderObject.slickNext();
        this.rightNav();
      });
    }
  }

  prevSlide() {
    if((Date.now() - this.state.lastNav) > 500) {
      this.setState({
        lastNav: Date.now(),
      }, () => {
        this.sliderObject.slickPrev();
        this.leftNav();
      });
    }
  }

  shouldShowRightArrow() {
    if(window.innerWidth <= this.state.singlePageBreak) {
      return this.state.currentPage < (this.state.pages.length - 2);
    } else {
      return this.state.currentPage < (this.state.pages.length - 2);
    }
  }

	render() {

    let settings = {
      dots: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: false,
      speed: 400,
      cssEase: "linear",
      arrows: false,
      adaptiveHeight: true,
    };

    let doublePage = window.innerWidth <= this.state.singlePageBreak;

    if(doublePage) {
      settings = {
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        speed: 400,
        cssEase: "linear",
        arrows: false,
        adaptiveHeight: true,
      };
    }

		return <div className={'Page'}>
      <div className='pageHeader'>
        <div className='headerWrapper'>
          <img src='/img/icon1.svg' />
        </div>
      </div>
      <div className='pageWrapper'>
        <div className='pageBackground'>
          <div className='pageBackgroundLeft'></div>
          <div className='pageBackgroundRight'></div>
          <div className='pageBackgroundMobile'></div>
        </div>
        <div className='pageContent'>
          <Slider ref={(slider) => { this.sliderObject = slider; }} {...settings}>
            {this.state.pages.map((page, index) => {
              return this.renderPage(page, index);
            })}
          </Slider>
        </div>
      </div>

      {this.getEffectivePage() ? 
        <div className='leftNav' onClick={::this.prevSlide}>
          <img src='/img/left.svg' />
        </div> :
        null
      }
      {this.shouldShowRightArrow() ?
        <div className='rightNav' onClick={::this.nextSlide}>
          <img src='/img/right.svg' />
        </div> :
        null
      }
      <div className='pageFooter'>
        <div className='footerWrapper'>Copyright &copy; 2022 Diamonds Direct USA. All rights reserved.</div>
      </div>
		</div>;
	}
}
export default Page;

function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

export const PageContainer = connect(
  mapStateToProps,
  allActionCreators
)(Page);


// WEBPACK FOOTER //
// ./src/components/views/page/Page.jsx